<template>
  <div class="containerBox" ref="box">
    <!--  顶部导航  -->
    <nav-bar />
    <!--  轮播图  -->
    <banner-list :banner-list="bannerList" />
    <!--   更多货源 -->
    <div class="more container">
      <div class="more_left" v-scroll-reveal="{origin: 'left'}">
        <img src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/morehy.png" alt="">
      </div>
      <div class="more_right" v-scroll-reveal="{origin: 'right'}">
        <p class="more_right_title">更多货源，更多收入</p>
        <p class="more_right_content">根据智能算法，为您匹配最合适的订单，从而减少等待时间及空载状态，帮助您提高收入。</p>
        <p class="more_right_title" style="margin-top: 60px;">货源真实，收入所见所得</p>
        <p class="more_right_content">严格的审核功能，在源头减少假单的困扰，承运前可对订单了解详情，让您对您的收入更有把握。</p>
      </div>
    </div>
    <!--   网络货运 -->
    <div class="network" v-scroll-reveal>
      <img src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/bg/htzg.png" alt="">
    </div>
    <!--   页面展示 -->
    <page-display :qrCodeData="qrCodeData" :navData="navData" typeTitle="司机端" />
    <!--  底部  -->
    <bottom-footer/>
    <!--  悬浮按钮  -->
    <fix-anchor @goBottom="goBottom" />
  </div>
</template>

<script>
import NavBar from '@/components/nav-bar.vue'
import BannerList from '@/components/banner-list.vue'
import BottomFooter from '@/components/bottom-footer.vue'
import FixAnchor from '@/components/fix-anchor.vue'
import PageDisplay from '@/components/page-display.vue'
import 'swiper/dist/js/swiper'
import 'swiper/dist/css/swiper.css'
export default {
  name: "ServeDriver",
  components: {
    NavBar,
    BannerList,
    BottomFooter,
    FixAnchor,
    PageDisplay
  },
  data() {
    return{
      bannerList: ['https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/banner/serve_driver_banner.png'],
      qrCodeData: [
        {
          id: 2,
          title: 'Android版',
          icon2: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/android.png',
          icon: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/android2.png',
          url: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/a_sj.png'
        },
        {
          id: 1,
          title: 'iOS版',
          icon2: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/ios.png',
          icon: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/ios2.png',
          url: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/i_sj.png'
        },
      ],
      navData: [
        {
          title: '货源列表',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/sj_hy.png'
        },
        {
          title: '签订合同',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/sj_ht.png'
        },
        {
          title: '钱包',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/sj_qb.png'
        },
        {
          title: '货源详情',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/sj_xq.png'
        },
      ],
    }
  },
  methods: {
    /**
     * @description: 页面滚动到顶部
     * @author: 书童
     */
    goBottom() {
      let top = this.$refs.box.offsetHeight, scrollTop = document.body.scrollTop, clientHeight = document.documentElement.clientHeight
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = scrollTop += 50
        if (top <= (scrollTop + clientHeight)) {
          clearInterval(timeTop)
        }
      }, 10)
    },
  }
}
</script>

<style scoped lang="scss">
.more{
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 712px;
  .more_left{
    width: 630px;
    height: 572px;
    margin-right: 70px;
    &>img{
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .more_right{
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .more_right_title{
      font-size: 30px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      text-align: LEFT;
      color: #333333;
      line-height: 42px;
      padding-left: 4px;
      box-sizing: border-box;
    }
    .more_right_content{
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      text-align: LEFT;
      color: #666666;
      line-height: 22px;
      margin-top: 20px;
    }
  }
}
.network{
  width: 100%;
  height: auto;
  &>img{
    display: block;
    width: 100%;
    height: auto;
  }
}
</style>